import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import dayjs from 'dayjs';
import cn from 'classnames';
import styled from 'styled-components';
import { TransportOrderCreateField } from './Field';
import { BaseComponent } from '../../../../components/BaseComponent';
import styles from './CreateFieldsColumns.module.css';
import {
  TRANSPORT_ORDER_COLUMN_1_ADD_TYPES,
  TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES,
  TRANSPORT_ORDER_COLUMN_1_PLAN_TYPES,
  TRANSPORT_ORDER_STATUS,
} from '../../constants';
import { setNewTransportOrderValue } from '../../actions';
import { selectWorks } from '../../../Api/selectors';
import { selectNewTransportOrder } from '../../selectors';
import { REQUEST_TRANSPORTERS } from '../../../Transporters/constants';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { VBox } from '../../../../components/Box';
import { Right } from '../../../../components/Icon';
import { Cell, List, Row } from '../../../../components/List';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { RegplateLabel } from '../../../Vehicles/components/RegplateLabel';
import { formatLicensePlate } from '../../../../utils/string';
import { TransportOrderCreateModal } from '.';
import { getDate, getVehicleTaskOpen } from '../../../Vehicles/helpers';

import { OnMouseOverNotification } from '../../../Vehicles/components/OnMouseOverNotification';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 12px;
  color: red;
`;
const STATE = {};

const ranges = {
  MediumSeaGreen: [2, 4],
  DarkOrange: [5, 7],
  Crimson: [8, Infinity],
};

/* eslint-disable react/prefer-stateless-function */
class CreateFieldsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, {
      modaltype: '', // Initialize modaltype state

      ...STATE,
    });
  }

  setModalToEdit = () => {
    this.setState({ modaltype: 'edit' });
    this.props.setModalToEdit(); // Call the function passed as a prop
  };

  componentDidMount() {}

  get secondColumnTypes() {
    return ['companyFromId', 'addressFromId'];
  }

  get thirdColumnTypes() {
    return ['companyToId', 'addressToId'];
  }

  applyDisabled() {
    if (
      (!this.props.values?.addressFromId && !this.props.values.addressFromManual) ||
      (!this.props.values?.addressToId && !this.props.values.addressToManual)
    )
      return true;

    return false;
  }

  reset() {
    return this.props.onClose();
  }

  renderOpennedTaskAlert(vehicle) {
    if (getVehicleTaskOpen(vehicle)?.length) {
      return (
        <OnMouseOverNotification
          message={
            <div className="d-flex flex-column gap-2">
              <span className="red-text">{this.lbl('kanbanboards.cell.has_open_task')}: </span>
              <span>{getVehicleTaskOpen(vehicle)[0]}</span>
            </div>
          }
          minWidth={'250px'}
          left={'0px'}
        />
      );
    }
    return null;
  }

  dateDifference(transportOrder) {
    const createdDate = transportOrder?.createdAt;
    if (!createdDate) return 0;

    const now = dayjs();
    const created = dayjs(createdDate);
    const diff = now.diff(created, 'day');

    return diff;
  }

  render() {
    const today = dayjs().format('YYYY-MM-DD hh:mm:ss');

    return this.props.from_location != 'overview' || this.state.modaltype == 'edit' ? (
      <div className={styles.GridContainer}>
        <div className={styles.GridItem}>
          <div className={styles.titleContainer}>
            <div className={styles.titleContainer}>
              <h3 className={styles.brandName}>
                {this.props.values?.vehicleManual ? this.props.values?.vehicleManual : this.props.vehicle?.brand_name}&nbsp;
                {this.props.vehicle?.model_name}
              </h3>
              <h3 className={styles.modelInfo}>
                {this.props.vehicle?.model_info}&nbsp;{this.props.vehicle?.type}&nbsp;{this.props.vehicle?.articlecode}
              </h3>
              <h3 className={styles.modelInfo}>
                <RegplateLabel regplate={this.props.vehicle?.regplate} />
              </h3>
            </div>

            {this.props.vehicle && this.renderOpennedTaskAlert(this.props.vehicle)}
            <div className={styles.infoBox}>
              <span className={styles.infoVehicle}>{formatLicensePlate(this.props.vehicle?.regplate)}</span>
              <span className={styles.infoVehicle}>
                {this.props.values?.vehicleManual ? '' : getDate(this.props.vehicle?.date_first_allowance)}
              </span>
            </div>
          </div>

          {this.props.from_location == 'vehicle_detail'
            ? TRANSPORT_ORDER_COLUMN_1_ADD_TYPES.map(type => (
                <TransportOrderCreateField
                  key={type}
                  type={type}
                  vehicleId={this.props.vehicleId}
                  addVehicleModal={this.props.addVehicleModal}
                  isPlan={this.state.isPlan}
                />
              ))
            : TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES.map(type => (
                <TransportOrderCreateField
                  key={type}
                  type={type}
                  vehicleId={this.props.vehicleId}
                  addVehicleModal={this.props.addVehicleModal}
                  bulkActionsList={this.props.bulkActionsList}
                  isPlan={this.state.isPlan}
                />
              ))}
          <VBox>
            {['datePlanned', 'transporterId']?.map(type => {
              if (!this.props.values?.[type] && this.state.isPlan) {
                return <RequireMark key={type}>{this.lbl(`transport_order.property.${type}`)}*</RequireMark>;
              }
            })}
          </VBox>
        </div>

        {/* a */}

        <div className={cn(styles.GridItem, styles.SecondColumn)}>
          {this.secondColumnTypes.map(type => (
            <TransportOrderCreateField
              vehicleId={this.props.vehicleId}
              key={type}
              type={type}
              addVehicleModal={this.props.addVehicleModal}
            />
          ))}
        </div>

        {/* a */}

        <div className={cn(styles.GridItem, styles.SecondColumn)}>
          {this.thirdColumnTypes.map(type => (
            <TransportOrderCreateField
              vehicleId={this.props.vehicleId}
              key={type}
              type={type}
              addVehicleModal={this.props.addVehicleModal}
            />
          ))}
        </div>

        {/* a */}
      </div>
    ) : (
      <>
        <div className={styles.titleContainer}>
          <div className={styles.titleContainer}>
            <Label count={this.dateDifference(this.props.values)} ranges={ranges}>
              {this.dateDifference(this.props.values) || '0'}
            </Label>
            <h3 className={styles.brandName}>
              {this.props.values?.vehicleManual ? this.props.values?.vehicleManual : this.props.vehicle?.brand_name}&nbsp;
              {this.props.vehicle?.model_name}
            </h3>
            <h3 className={styles.modelInfo}>
              {this.props.vehicle?.model_info}&nbsp;{this.props.vehicle?.type}&nbsp;{this.props.vehicle?.articlecode}
            </h3>
            <h3 className={styles.modelInfo}>
              <RegplateLabel regplate={this.props.vehicle?.regplate} />
            </h3>
          </div>
          {this.props.vehicle && this.renderOpennedTaskAlert(this.props.vehicle)}
          <div className={styles.infoBox}>
            <span className={styles.infoVehicle}>{formatLicensePlate(this.props.vehicle?.regplate)}</span>
            <span className={styles.infoVehicle}>
              {this.props.values?.vehicleManual ? '' : getDate(this.props.vehicle?.date_first_allowance)}
            </span>
          </div>
        </div>

        <div className="d-flex gap-1 p-4">
          <div className="card p-3 w-100 cursor-pointer shadow-sm transition-all border-secondary">
            <p className="text-dark fw-medium">{this.props.values?.companyFrom?.name}</p>
            <p className="text-muted m-0">{this.props.values?.addressFrom?.addressLine1}</p>
            <p className="text-muted m-0">
              {this.props.values?.addressFrom?.postcode} {this.props.values?.addressFrom?.city}
            </p>
            <p className="text-dark fw-medium m-0">{this.props.values?.companyFrom?.telephonenr}</p>
          </div>
          <div>
            <Right />
          </div>
          <div className="card p-3 w-100 cursor-pointer shadow-sm transition-all border-secondary">
            <p className="text-dark fw-medium">{this.props.values?.companyTo?.name}</p>
            <p className="text-muted m-0">{this.props.values?.addressTo?.addressLine1}</p>
            <p className="text-muted m-0">
              {this.props.values?.postcode} {this.props.values?.addressTo?.city}
            </p>
            <p className="text-dark fw-medium m-0">{this.props.values?.telephonenr}</p>
          </div>
        </div>

        <List>
          {[
            { key: 'status', label: 'status' },
            //als this.props.values?.status == 'initated' laat dat de datePlanned zien
            ...(this.props.values?.status === TRANSPORT_ORDER_STATUS.Done
              ? [{ key: 'transporter.name', label: 'transporter' }]
              : []),
            ...(this.props.values?.status === TRANSPORT_ORDER_STATUS.Done ? [{ key: 'dateDone', label: 'dateDone' }] : []),
            ...(this.props.values?.status === TRANSPORT_ORDER_STATUS.Done
              ? [{ key: 'datePlanned', label: 'datePlanned' }]
              : []),

            ...(this.props.values?.status === TRANSPORT_ORDER_STATUS.Initiated
              ? [{ key: 'datePlanned', label: 'datePlanned' }]
              : []),
            // { key: 'createdAt', label: 'createdAt' },

            { key: 'dateToPlan', label: 'dateToPlan' },

            ...(this.props.values?.individual === '1' ? [{ key: 'individual', label: 'Los transport' }] : []),

            ...(this.props.values?.status === TRANSPORT_ORDER_STATUS.Done ? [{ key: 'remarks', label: 'remarks' }] : []),
          ].map(({ key, label }) => {
            let value = key.split('.').reduce((obj, field) => obj?.[field], this.props.values); // Safe deep access

            let formattedValue = value; // Default to raw value
            let isFutureDate = false; // Default state

            // Format date fields
            if (['dateToPlan', 'dateDone', 'createdAt', 'datePlanned'].includes(key) && value) {
              const date = new Date(value);
              formattedValue = date.toLocaleDateString('nl-NL', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              });

              isFutureDate = key === 'dateToPlan' && date > new Date();
            }

            return (
              <Row key={key}>
                <Cell>{this.lbl(`vehicle.property.${label}`)}</Cell>
                <Cell style={{ color: isFutureDate ? 'red' : 'inherit' }}>
                  <span style={{ color: isFutureDate ? 'red' : 'inherit' }}>
                    {label === 'status' ? (
                      <VehicleStatusLabel status={value}>{this.lbl('transport_order.filter.' + value)}</VehicleStatusLabel>
                    ) : key === 'individual' ? (
                      'Ja'
                    ) : (
                      formattedValue || '-'
                    )}
                  </span>
                </Cell>
              </Row>
            );
          })}
        </List>

        {this.props.values?.status != TRANSPORT_ORDER_STATUS.Done && (
          <>
            <div className={styles.GridItem}>
              {TRANSPORT_ORDER_COLUMN_1_PLAN_TYPES.map(type => (
                <TransportOrderCreateField
                  key={type}
                  type={type}
                  vehicleId={this.props.vehicleId}
                  addVehicleModal={this.props.addVehicleModal}
                  bulkActionsList={this.props.bulkActionsList}
                  isPlan={this.state.isPlan}
                  transportOrderId={this.props.values?.id}
                  isEdit
                />
              ))}
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <ButtonComponent style="ButtonSoftPrimaryFullWidth" onClick={this.setModalToEdit}>
                Bewerken
              </ButtonComponent>

              <ButtonComponent
                style="ButtonSoftPrimaryFullWidth"
                disabled={!this.props.values?.datePlanned || !this.props.values?.transporterId}
                onClick={() => {
                  if (!this.props.values?.datePlanned || !this.props.values?.transporterId) {
                    this.setState({ isPlan: true });
                  } else {
                    this.setState({ isPlan: false });
                    this.props.setValue(TRANSPORT_ORDER_STATUS.Initiated, 'status');
                    this.props.saveWithPlanVehicle();
                  }
                }}
              >
                {this.props.values?.status === TRANSPORT_ORDER_STATUS.Initiated ? this.lbl('Opslaan') : this.lbl('Plan')}
              </ButtonComponent>
              {this.props.values?.status == TRANSPORT_ORDER_STATUS.Initiated && (
                <ButtonComponent
                  style="ButtonDelete"
                  onClick={() => {
                    if (window.confirm('Weet je zeker dat je het transport wilt resetten?')) {
                      this.setState({ isPlan: false });
                      this.props.setValue(TRANSPORT_ORDER_STATUS.Requested, 'status');
                      this.props.setValue('dateDone', null);
                      this.props.setValue('datePlanned', null);
                      this.props.setValue('transporter', null);
                      this.props.saveWithResetVehicle();
                    }
                  }}
                >
                  {this.lbl('transport_order.action.reset')}
                </ButtonComponent>
              )}
            </div>
          </>
        )}
        {this.props.values?.status === TRANSPORT_ORDER_STATUS.Initiated && (
          <div style={{ marginTop: '10px' }}>
            <ButtonComponent
              style="ButtonSoftEditFullWidth"
              onClick={() => {
                this.setState({ isPlan: false });
                this.props.setValue(TRANSPORT_ORDER_STATUS.Done, 'status');
                this.props.setValue('dateDone', today);
                this.props.saveWithDoneVehicle();
              }}
            >
              {this.lbl('transport_order.action.afronden')}
            </ButtonComponent>
          </div>
        )}
      </>
    );
  }
}

// Update propTypes to include setModalToEdit
CreateFieldsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  reset: PropTypes.func,
  onNextModal: PropTypes.func,
  setModalToEdit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workTransporters: selectWorks([REQUEST_TRANSPORTERS]),
    values: selectNewTransportOrder(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    setValue(value, name) {
      dispatch(setNewTransportOrderValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreateFieldsColumns = compose(withConnect, withRouter, injectIntl)(CreateFieldsColumnsComp);
